import React from "react";
import { FormattedMessage } from "react-intl";
import { Row, Col } from "reactstrap";
import moment from "moment";
import { transformBytesInKb } from "../../../../helpers/general";

function PackageDocumentsSection(props) {
  const {
    packageDetails: {
      documents = [],
      signers_count = 0,
      signers_signed_count = 0,
    } = {},
  } = props;

  const renderDocuments = () => {
    if (!Array.isArray(documents) || documents.length === 0) {
      return (
        <>
          <h6 className="heading-small">
            <FormattedMessage id="pages.documents.sections.packageDocumentsSection.title" />
          </h6>
          <Row>
            <Col className="mt-3">
              <FormattedMessage id="messages.no_data" />
            </Col>
          </Row>
        </>
      );
    }

    return documents.map(renderDocument);
  };

  const renderDocument = (document, index) => {
    
    return (
      <div key={index}>
        <h6 className="heading-small">
          <FormattedMessage id="pages.documents.sections.packageDocumentsSection.document" />
          {`: ${document.name}`}
        </h6>
        <Row className="ml-lg-n3 mr-lg-n3 m-0">
          <Col className="col-auto mt-3 col-lg-6 p-0 p-lg-3 table-responsive">
            <table className="table-bordered table-striped table p-0">
              <tbody>
                <tr>
                  <th className="text-nowrap" scope="row">
                    <FormattedMessage id="pages.documents.sections.packageDocumentsSection.document_created_at" />
                  </th>
                  <td>{moment(document.created_at).format("lll")}</td>
                </tr>
                <tr>
                  <th className="text-nowrap" scope="row">
                    <FormattedMessage id="pages.documents.sections.packageDocumentsSection.document_name" />
                  </th>
                  <td>{document.name}</td>
                </tr>
                <tr>
                  <th className="text-nowrap" scope="row">
                    <FormattedMessage id="pages.documents.sections.packageDocumentsSection.document_storage_name" />
                  </th>
                  <td>{document.storage_name}</td>
                </tr>
              </tbody>
            </table>
          </Col>
          <Col className="col-auto mt-3 col-lg-6 p-0 p-lg-3 table-responsive">
            <table className="table-bordered table-striped table p-0">
              <tbody>
                <tr>
                  <th className="text-nowrap" scope="row">
                    <FormattedMessage id="pages.documents.sections.packageDocumentsSection.document_size" />
                  </th>
                  <td>{transformBytesInKb(document.size)}</td>
                </tr>
                <tr>
                  <th className="text-nowrap" scope="row">
                    <FormattedMessage id="pages.documents.sections.packageDocumentsSection.document_language_name" />
                  </th>
                  <td>{document.language.name}</td>
                </tr>
                <tr>
                  <th className="text-nowrap" scope="row">
                    <FormattedMessage id="pages.documents.sections.packageDocumentsSection.document_signers" />
                  </th>
                  <td>
                    {signers_signed_count} / {signers_count}
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
        <hr className="my-4" />
      </div>
    );
  };

  return <>{renderDocuments()}</>;
}

export { PackageDocumentsSection };
